import { apiGet } from "./client";

export const adminApi = {
  stats: () => apiGet("/api/admin/stats"),
};
